import { useMemo, useState } from 'react'

import { styled } from 'styled-components'

import { LoadingContainer, ModelList, Button } from 'peach/components'
import { useClickAction } from 'peach/decorators/withActionTrigger'
import { humanizeKey } from 'peach/helpers'
import { useParams, useRouteMatch, useHistory } from 'peach/router'

import { Page, Switch } from 'core/components'
import { R } from 'core/helpers'
import { useCompanyLoanConfigurationsGetAllPaged } from 'core/types'
import type { CompanyLoanConfigurationsGetAllVariables } from 'core/types/generated/loan-types/operations'

const LoanTypes = () => {
  const { companyId } = useParams<{ companyId?: string }>()
  const { url } = useRouteMatch()
  const history = useHistory()

  const [isExcludeInactive, setExcludeInactive] = useState(true)

  const query = useMemo((): NonNullable<
    CompanyLoanConfigurationsGetAllVariables['query']
  > => {
    const base = { sortBy: ['-createdAt'], limit: 100 }
    return isExcludeInactive ? { ...base, status: ['active'] } : base
  }, [isExcludeInactive])

  const {
    data: loanTypes,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useCompanyLoanConfigurationsGetAllPaged({ companyId, query })

  useClickAction({
    label: 'Create Installment Loan Type',
    onClick: () => history.push(`${url}/create-installment-loan-type`),
  })

  useClickAction({
    label: 'Create Line Of Credit Loan Type',
    onClick: () => history.push(`${url}/create-line-of-credit-loan-type`),
  })

  return (
    <LoadingContainer isLoading={isLoading}>
      <Page variant='full'>
        <SwitchContainer>
          <Switch
            checked={isExcludeInactive}
            id='loan-types-exclude-inactive'
            label='Exclude Inactive'
            name='excludeInactive'
            onCheckedChange={setExcludeInactive}
          />
        </SwitchContainer>
        {R.pipe(
          loanTypes ?? [],
          R.groupBy((lt) => lt.type ?? 'unknown'),
          R.toPairs,
          R.map(([key, group]) => (
            <ModelList json={group} key={key} title={humanizeKey(key)} />
          )),
        )}

        <Box>
          <Button
            disabled={!hasNextPage || isFetchingNextPage}
            onClick={() => fetchNextPage()}
          >
            Fetch Next Page
          </Button>
        </Box>
      </Page>
    </LoadingContainer>
  )
}

export default LoanTypes

const SwitchContainer = styled.div`
  margin-bottom: 12px;
`

const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`
